var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_28020)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_311_28020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0007 39.1667C38.8956 39.1667 37.8358 38.7277 37.0544 37.9463C36.273 37.1649 35.834 36.1051 35.834 35C35.834 33.895 36.273 32.8352 37.0544 32.0538C37.8358 31.2724 38.8956 30.8334 40.0007 30.8334C41.1057 30.8334 42.1655 31.2724 42.9469 32.0538C43.7283 32.8352 44.1673 33.895 44.1673 35C44.1673 35.5472 44.0595 36.089 43.8502 36.5946C43.6408 37.1001 43.3338 37.5594 42.9469 37.9463C42.56 38.3332 42.1007 38.6401 41.5952 38.8495C41.0896 39.0589 40.5478 39.1667 40.0007 39.1667ZM40.0007 23.3334C36.9065 23.3334 33.939 24.5625 31.7511 26.7505C29.5631 28.9384 28.334 31.9058 28.334 35C28.334 43.75 40.0007 56.6667 40.0007 56.6667C40.0007 56.6667 51.6673 43.75 51.6673 35C51.6673 31.9058 50.4382 28.9384 48.2502 26.7505C46.0623 24.5625 43.0948 23.3334 40.0007 23.3334Z",
    fill: "url(#paint0_linear_311_28020)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_311_28020",
    x: 13.334,
    y: 12.3334,
    width: 53.334,
    height: 63.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_311_28020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_311_28020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_28020",
    x1: 28.334,
    y1: 40,
    x2: 51.6673,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0B3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#107650"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_28020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/contact_location.daabcb7bfb5a17833313a76416f31231.svg";
export { ForwardRef as ReactComponent };